import React, { useState, useEffect } from 'react';
import axios from 'axios';
import GroupeSelector from './GroupeSelector';
import { ReactComponent as Close } from './../svg/close.svg';
import { parseGroupString } from './../utils';
const ip = process.env.REACT_APP_IP;

const NouveauPerso = ({ idJoueur, setNewClick, setSelectedPerso, perso, energies,token }) => {
    const modif = perso != null;
    const [nom, setNom] = useState(modif ? perso.nom : "");
    const [idPerso, setIdPerso] = useState(modif ? perso.idPersonnage : "");
    const [nomMagique, setNomMagique] = useState(modif ? perso.nom_magique : "");
    const [prenom, setPrenom] = useState(modif ? perso.prenom : "");
    const [taille, setTaille] = useState(modif ? perso.Taille : "");
    const [age, setAge] = useState(modif ? perso.Age : "");
    const [origine, setOrigine] = useState(modif ? perso.Origine : "");
    const [image, setImage] = useState(modif ? perso.profilPath : "/Images/Profile_pic/default.jpg");
    const [race, setRace] = useState(modif ? perso.Race : "");
    const [statsFixe, setStatsFixe] = useState(modif ? [perso.Intelligence,perso.Social,perso.Observation] :[10, 10, 10]);
    const [statsVar, setStatsVar] = useState(modif ? [perso.Agilité,perso.Force,perso.CapMagique] :[10, 10, 10]);
    const [statsVarLvl, setStatsVarLvl] = useState(modif ? [perso.NiveauAgilité,perso.Niveau_Force,perso.NiveauCapMagique] :[1, 1, 1]);
    const [selectedGroupe, setSelectedGroupe] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');
    const [vie, setVie] = useState(modif ? energies["Vie"]["Vie"].maximum : 1);
    const [energie, setEnergie] = useState(modif ? energies["Energie"]["Energie"].maximum : 1);
    const maxdistrib = modif ? (perso.Niveau*5)+135 + (["Kass", "Surya"].includes(perso.prenom) ? 10 : 0) : 140;
    const maxdistribVar = modif ? (Math.floor(perso.Niveau / 10) * 5) + 140 : 140;
    const maxEnergies = modif ? perso.Niveau+ 19 : 20;
    const handleNew = async () => {
        if (!checkAllFieldsFilled()) {
            return;
        }

        try {
            
            const formData = {
                nom,
                prenom,
                taille,
                age,
                origine,
                race,
                image,
                statsVar,
                statsVarLvl,
                statsFixe,
                login: idJoueur,
                group: selectedGroupe,
                energie,
                vie
            };

            console.log('FormData:', formData);
            if(!modif){
                const response = await axios.post(`${ip}/personnage`, formData, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    }
                }); 
                var perso = {
                    "idPersonnage": response.data.id
                };
                setSelectedPerso(perso);
                console.log('Réponse du serveur :', response.data);
            }else{
                const response = await axios.put(`${ip}/personnage/`+idPerso, formData, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    }
                });
                console.log('Réponse du serveur :', response.data);
            }
            

            
            setNewClick(false);

        } catch (error) {
            console.error('Erreur lors de la requête :', error);
            setErrorMessage("Erreur lors de la création du personnage. Veuillez réessayer.");
        }
    };

    const checkAllFieldsFilled = () => {
        if (nom === "" ||
            prenom === "" ||
            taille === "" ||
            age === "" ||
            origine === "" ||
            race === "") {
            setErrorMessage("Tous les champs doivent être remplis !");
            return false;
        }
        if (maxdistrib - calculateSum(statsFixe) !== 0 || maxdistribVar - (calculateSum(statsVar) + (30 * (calculateSum(statsVarLvl) - 3))) !== 0 || validateEnergies() !== 0) {
            //setErrorMessage("Toutes les statistiques doivent être remplies !");
            return true;
        }
        setErrorMessage('');
        return true;
    };
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    useEffect(() => { }, [image]);

    useEffect(() => { }, []);
    const readFileAsDataURL = (file) => {
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result);  // Assuming 'setImage' is available here
            };
            reader.readAsDataURL(file);
        }
    };
    const validateStat = (value, level, min = 10, max = 80) => {
        const minValue = level > 1 ? 50 : min;
        if (value < minValue) return minValue;
        if (value > max) return max;
        return value;
    };

    const handleStatFixeChange = (index, value) => {
        const newStats = [...statsFixe];
        newStats[index] = value;
        setStatsFixe(newStats);
    };

    const validateEnergies = () => {
        return maxEnergies - (Number(energie) + Number(vie));
    };

    const handleStatVarChange = (index, value) => {
        const newStats = [...statsVar];
        newStats[index] = value;
        setStatsVar(newStats);
    };

    const handleStatVarLvlChange = (index, value) => {
        const newStats = [...statsVarLvl];
        newStats[index] = value;
        setStatsVarLvl(newStats);

        if (value > 1 && statsVar[index] < 50) {
            const newVarStats = [...statsVar];
            newVarStats[index] = 50;
            setStatsVar(newVarStats);
        }
    };

    const handleBlurStatFixe = (index, value) => {
        const validatedValue = validateStat(value, 1);
        const newStats = [...statsFixe];
        newStats[index] = validatedValue;
        setStatsFixe(newStats);
    };

    const handleBlurStatVar = (index, value) => {
        const validatedValue = validateStat(value, statsVarLvl[index]);
        const newStats = [...statsVar];
        newStats[index] = validatedValue;
        setStatsVar(newStats);
    };

    const calculateSum = (array) => array.reduce((acc, curr) => acc + curr, 0);

    const handleVieChange = (value) => {
        const newVie = Number(value);
        if (newVie >= 0) {
            setVie(newVie);
        }
    };

    const handleEnergieChange = (value) => {
        const newEnergie = Number(value);
        if (newEnergie >= 0) {
            setEnergie(newEnergie);
        }
    };

    const handleBlurVieChange = (value) => {
        const newVie = Number(value);
        if (newVie <= 0) {
            setVie(1);
        } else if (validateEnergies() < 0) {
            // setVie(maxEnergies - energie)
        }
    };

    const handleBlurEnergieChange = (value) => {
        const newEnergie = Number(value);
        if (newEnergie <= 0) {
            setEnergie(1);
        } else if (validateEnergies() < 0) {
            // setEnergie(maxEnergies - vie)
        }
    };

    return (
        <React.Fragment>
            <Close onClick={() =>setNewClick(false)} className='close_page'/>
            <div className='flex flex_column'>
                <img className='profil_pic center_self margin border-profil' src={image} alt="Profile" />
                <input className='centerText ' type="file" onChange={handleFileChange} accept="image/*" />
                <span className='margin_1em_LR title_input'>Prénom</span>
                <input className='margin_1em input-transparent' type='text' value={prenom} placeholder='Prenom' onChange={(e) => setPrenom(e.target.value)} />
                <span className='margin_1em_LR title_input'>Nom</span>
                <input className='margin_1em input-transparent' type='text' value={nom} placeholder='Nom' onChange={(e) => setNom(e.target.value)} />
                
                <div className='grid_2colauto'>
                    <div className='margin_1em_notop flex_column flex'>
                        <span className='margin_bot1 title_input'>Age</span>
                        <input className='input-transparent' type='number' value={age} placeholder='Age' onChange={(e) => setAge(Number(e.target.value))} />
                    </div>
                    <div className='margin_1em_notop flex_column flex'>
                        <span className='margin_bot1 title_input'>Taille (cm)</span>
                        <input className='input-transparent' type='number' value={taille} placeholder='Taille (En cm)' onChange={(e) => setTaille(Number(e.target.value))} />
                    </div>
                </div>
                <span className='margin_1em_LR title_input'>Origine</span>
                <input className='margin_1em input-transparent' type='text' value={origine} placeholder='Origine' onChange={(e) => setOrigine(e.target.value)} />
                <span className='margin_1em_LR title_input'>Race</span>
                <input className='margin_1em input-transparent' type='text' value={race} placeholder='Race' onChange={(e) => setRace(e.target.value)} />
                <span className='margin_1em_LR title_input'>Groupe</span>
                <GroupeSelector selectedGroupe={selectedGroupe} setSelectedGroupe={setSelectedGroupe} modif={modif} token={token}/>
                <div className='centerText point_restant'>Restant : {validateEnergies()}</div>
                <div className="grid_2col margin_1em">
                    <div className="item test Vie">Vie</div>
                    <div className="item Energie">Energie</div>
                    <div className="item VieFade">
                        <input
                            type='number'
                            className="width_3em centerText no_bg"
                            value={Number(vie).toString()}
                            onChange={(e) => handleVieChange(e.target.value)}
                            onBlur={(e) => handleBlurVieChange(e.target.value)}
                            onFocus={(e) => e.target.select()}
                        />
                    </div>
                    <div className="item EnergieFade">
                        <input
                            type='number'
                            className="width_3em centerText no_bg"
                            value={Number(energie).toString()}
                            onChange={(e) => handleEnergieChange(e.target.value)}
                            onBlur={(e) => handleBlurEnergieChange(e.target.value)}
                            onFocus={(e) => e.target.select()}
                        />
                    </div>
                </div>
                <div className='centerText point_restant'>Restant : {maxdistribVar - calculateSum(statsFixe)}</div>
                <div className="grid margin_1em">
                    <div className="item test Intelligence">Intelligence</div>
                    <div className="item Social">Social</div>
                    <div className="item Observation">Observation</div>
                    <div className="item IntelligenceFade">
                        <input
                            type='number'
                            className="width_3em centerText no_bg"
                            value={statsFixe[0]}
                            onChange={(e) => handleStatFixeChange(0, Number(e.target.value))}
                            onBlur={(e) => handleBlurStatFixe(0, Number(e.target.value))}
                            onFocus={(e) => e.target.select()}
                        />
                    </div>
                    <div className="item SocialFade">
                        <input
                            type='number'
                            className="width_3em centerText no_bg"
                            value={statsFixe[1]}
                            onChange={(e) => handleStatFixeChange(1, Number(e.target.value))}
                            onBlur={(e) => handleBlurStatFixe(1, Number(e.target.value))}
                            onFocus={(e) => e.target.select()}
                        />
                    </div>
                    <div className="item ObservationFade">
                        <input
                            type='number'
                            className="width_3em centerText no_bg"
                            value={statsFixe[2]}
                            onChange={(e) => handleStatFixeChange(2, Number(e.target.value))}
                            onBlur={(e) => handleBlurStatFixe(2, Number(e.target.value))}
                            onFocus={(e) => e.target.select()}
                        />
                    </div>
                </div>
                <div className='centerText point_restant'>
                    Restant : {maxdistrib - (calculateSum(statsVar) + (30 * (calculateSum(statsVarLvl) - 3)))}
                </div>
                <div className="grid margin_1em">
                    <div className="item Agilite">Agilité</div>
                    <div className="item Force">Force</div>
                    <div className="item CapMagique">Capacité Magique</div>
                    <div className="item AgiliteFade">
                        <select className='dropdown-stat' value={statsVarLvl[0]} onChange={(e) => handleStatVarLvlChange(0, Number(e.target.value))}>
                            <option className='AgiliteFade' value={1}>1</option>
                            <option className='AgiliteFade' value={2}>2</option>
                            <option className='AgiliteFade' value={3}>3</option>
                        </select>
                    </div>
                    <div className="item ForceFade">
                        <select className='dropdown-stat' value={statsVarLvl[1]} onChange={(e) => handleStatVarLvlChange(1, Number(e.target.value))}>
                            <option className='ForceFade' value={1}>1</option>
                            <option className='ForceFade' value={2}>2</option>
                            <option className='ForceFade' value={3}>3</option>
                        </select>
                    </div>
                    <div className="item CapMagiqueFade">
                        <select className='dropdown-stat' value={statsVarLvl[2]} onChange={(e) => handleStatVarLvlChange(2, Number(e.target.value))}>
                            <option className='CapMagiqueFade' value={1}>1</option>
                            <option className='CapMagiqueFade' value={2}>2</option>
                            <option className='CapMagiqueFade' value={3}>3</option>
                        </select>
                    </div>
                    <div className="item AgiliteFade2">
                        <input
                            type='number'
                            className="width_3em centerText no_bg"
                            value={statsVar[0]}
                            onChange={(e) => handleStatVarChange(0, Number(e.target.value))}
                            onBlur={(e) => handleBlurStatVar(0, Number(e.target.value))}
                            onFocus={(e) => e.target.select()}
                        />
                    </div>
                    <div className="item ForceFade2">
                        <input
                            type='number'
                            className="width_3em centerText no_bg"
                            value={statsVar[1]}
                            onChange={(e) => handleStatVarChange(1, Number(e.target.value))}
                            onBlur={(e) => handleBlurStatVar(1, Number(e.target.value))}
                            onFocus={(e) => e.target.select()}
                        />
                    </div>
                    <div className="item CapMagiqueFade2">
                        <input
                            type='number'
                            className="width_3em centerText no_bg"
                            value={statsVar[2]}
                            onChange={(e) => handleStatVarChange(2, Number(e.target.value))}
                            onBlur={(e) => handleBlurStatVar(2, Number(e.target.value))}
                            onFocus={(e) => e.target.select()}
                        />
                    </div>
                </div>
                <button className='margin_1em input-transparent' onClick={handleNew}>{modif ? "Mise à jour" : "Créer"}</button>
                {errorMessage && <p className='error'>{errorMessage}</p>}
            </div>

        </React.Fragment>
    );
};

export default NouveauPerso;
